import React, { useState, useEffect } from 'react';
import Header from '../components/Header'

import {
	Box,
	HStack,
	Flex,
	Text,
	Table,
	Thead,
	Tbody,
	Image,
	Tr,
	Th,
	Td,
	TableContainer,
	Button,
	useDisclosure,
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
	Heading,
	MenuDivider,
	Tabs, TabList, TabPanels, Tab, TabPanel,
	Wrap,
	WrapItem,
	Tag,
	Switch,
	Icon
} from '@chakra-ui/react'

import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { fetchWrapper } from '../helpers';
import customer_edit_icon from '../images/customer_edit_icon.png'
import 'moment-timezone';
import CustomModalLink from '../components/CustomModalLink'
import { LuChevronDown, LuBuilding2, LuUser, LuPhone, LuTag, LuWallet, LuServer } from 'react-icons/lu'
import DailyMessageChart from './chart/daily-msg.chart';
import CountryWiseChart from './chart/country-wise-msg.chart';
import CountryWiseCost from './chart/country-wise-cost.chart';
import Create from './customer-user/Create'
import ChangePass from './customer-user/ChangePassword';
import UserEdit from './customer-user/Edit';
import Edit from './customer/Edit'
import AddBalance from './customer/AddBalance'
import EditRate from './customer/EditRate'
import TemplateMapping from './CustomerDetailsComponents/TemplateMapping';
import Transaction from './CustomerDetailsComponents/Transaction';
import MessageLog from './CustomerDetailsComponents/MessageLog';
import TpsChannel from './CustomerDetailsComponents/TpsChannel';
import AllowedCountriesManagement from './CustomerDetailsComponents/AllowedCountry';
import DuplicateSetting from './CustomerDetailsComponents/DuplicateSetting';
import CustomerValidation from './CustomerDetailsComponents/CustomerValidation';
import PagePermission from './CustomerDetailsComponents/PagePermission';
import TextTemplate from './CustomerDetailsComponents/TextTemplate';
import CustomerSupport from './CustomerDetailsComponents/CustomerSupport';
import StoryBuilderAI from './CustomerDetailsComponents/StoryBuilderAI';
import OptInOut from './CustomerDetailsComponents/OptInOut';
import PageLoader from '../components/Loader/PageLoader';
import BoxWrapper from '../components/BoxWrapper/BoxWrapper';

const CustomerDetail = () => {
	const [detail, setDetail] = useState({})
	const [balance, setBalance] = useState(0)

	const [listUser, setListUser] = useState([])
	const [dailymsg, setDailymsg] = useState([])
	const [countrymsg, setCountrymsg] = useState([])
	const [countryCost, setCountryCost] = useState([])
	const [messageTemplateTypeList, setMessageTemplateTypeList] = useState([])
	const [messageTemplateList, setMessageTemplateList] = useState([])

	const { state } = useLocation();
	const { id: paramId } = useParams();
	const id = state?.id || paramId;
	const [loading, setloading] = useState(false);
	const [modalHeader, setmodelHeader] = useState('');
	const { onOpen: onOpenEdit } = useDisclosure();
	const [isOpenEdit, setIsOpenEdit] = useState(false)
	const [modalEditView, setModalEditView] = useState(false)

	const [formData, setFormData] = useState({

		template_id: [],

	});
	const navigate = useNavigate()
	const [searchParams, setSearchParams] = useSearchParams();
	const tabParam = parseInt(searchParams.get("tab")) || 0; // fallback to 0 if null or NaN
	const [activeTab, setActiveTab] = useState(tabParam);


	useEffect(() => {
		// Add a cleanup function to prevent state updates after unmount
		let isMounted = true;

		const loadAllData = async () => {
			try {
				setloading(true);
				await Promise.all([
					loadDetail(),
					LoadUser(),
					loadChart(),
					LoadMessageTemplateType(),
					LoadMessageTemplate(),
				]);
			} catch (error) {
				console.error("Error loading data:", error);
				// Show user-friendly error message
			} finally {
				if (isMounted) setloading(false);
			}
		};

		loadAllData();

		return () => {
			isMounted = false;
		};
	}, []);

	const loadDetail = async () => {
		// setloading(true)
		const url = `${process.env.REACT_APP_API_URL}/customer/by-id?id=${id}`;
		const data = await fetchWrapper.get(url)
		const customerConfig = data.data.config;

		const defaultIds = await buuldTemplateType()
		const template_settings = JSON.parse(customerConfig)?.template_settings ? JSON.parse(customerConfig).template_settings : defaultIds;

		setFormData({
			template_id: template_settings
		})
		setDetail(data.data)
		setBalance(data.balance)
		setloading(false)

	}

	const buuldTemplateType = async () => {
		setloading(true)
		const url = `${process.env.REACT_APP_API_URL}/message-template-type/list`;
		const data = await fetchWrapper.get(url)

		const ids = data.data.map(item => {

			return { message_template_type_id: item.id, value: '' };
		})
		setloading(false)
		return ids;

	}

	const LoadMessageTemplate = async () => {
		setloading(true)
		const url = `${process.env.REACT_APP_API_URL}/template-message/list`;
		const data = await fetchWrapper.get(url)
		setMessageTemplateList(data)
		setloading(false)

	}

	const LoadMessageTemplateType = async () => {
		setloading(true)
		const url = `${process.env.REACT_APP_API_URL}/message-template-type/list?customer_id=${id}`;
		const data = await fetchWrapper.get(url)
		setMessageTemplateTypeList(data.data)
		setloading(false)

	}


	const loadChart = async () => {
		setloading(true)
		const url = `${process.env.REACT_APP_API_URL}/msg-log-chart?customer_id=${id}`;
		const data = await fetchWrapper.get(url)

		setDailymsg(data.Dailymsg)
		setCountrymsg(data.CountryWiseCount)
		setCountryCost(data.CountryWiseCost)
		setloading(false)

	}


	const LoadUser = async () => {
		setloading(true)
		const url = `${process.env.REACT_APP_API_URL}/user/list?customer_id=${id}`;
		const data = await fetchWrapper.get(url)
		setListUser(data.data);
		setloading(false)
	}


	// useEffect(() => {
	// 	// Only update if different to prevent re-render loops
	// 	if (activeTab !== tabParam) {
	// 		setActiveTab(tabParam);
	// 	}
	// }, [tabParam, activeTab]);


	const handleTabChange = (index) => {
		setActiveTab(index);
		const newParams = new URLSearchParams(searchParams);
		newParams.set("tab", index);
		setSearchParams(newParams, { replace: true });
	};




	const meAddUser = () => {
		setIsOpenEdit(true);
		setmodelHeader('Create User')
		setModalEditView(<Create meCloseEdit={meCloseEdit} customer_id={id} loadList={LoadUser} />)
	}

	const meChangePass = (rs) => {
		setIsOpenEdit(true);
		setmodelHeader('Change Password')
		setModalEditView(<ChangePass meCloseEdit={meCloseEdit} rs={rs} loadList={LoadUser} />)
	}


	const changeStatus = async (type, rs) => {

		if (type === "status") {
			const data = {
				status_id: rs.status_id ? 0 : 1,
				customer_id: rs.customer_id,
				id: rs.id
			}
			const url = `${process.env.REACT_APP_API_URL}/user/update`;
			await fetchWrapper.post(url, data)
			LoadUser()
		}

		if (type === "edit") {
			setIsOpenEdit(true);
			setmodelHeader('User Edit')
			setModalEditView(<UserEdit meCloseEdit={meCloseEdit} rs={rs} loadList={LoadUser} />)
		}

	}


	const meCloseEdit = () => {

		setIsOpenEdit(false);

	}
	const roundMe = (num) => {

		if (num) {
			return num.toFixed(4)
		}

	}


	const meEdit = (type) => {
		if (type === "server") {
			setIsOpenEdit(true);
			setmodelHeader('Edit Server Ip')
			setModalEditView(<Edit meCloseEdit={meCloseEdit} rs={detail} loadList={loadDetail} />)
		}

		if (type === "add") {
			setIsOpenEdit(true);
			setmodelHeader('Add Balance')
			setModalEditView(<AddBalance meCloseEdit={meCloseEdit} rs={detail} loadList={LoadUser} balance={balance} />)
		}

		if (type === "sms") {
			setIsOpenEdit(true);
			setmodelHeader('Add Balance')
			setModalEditView(<EditRate meCloseEdit={meCloseEdit} rs={detail} loadList={loadDetail} />)
		}
	}





	const handleActiveInActive = (rs) => {
		const url = `${process.env.REACT_APP_API_URL}/user/update-status`;
		const data = {
			id: rs.id,
			status_id: rs.status_id === 1 ? 0 : 1,
			customer_id: id
		}
		setListUser([])
		fetchWrapper.post(url, data).then((res) => {
			LoadUser()
		})
	}

	const handleSuperAdminToggle = async (rs) => {
		const url = `${process.env.REACT_APP_API_URL}/user/update-super-admin`;
		const data = {
			super_admin: rs.super_admin === 1 ? 0 : 1,
			customer_id: id,
			id: rs.id
		}
		try {
			await fetchWrapper.post(url, data);
			LoadUser();
		} catch (error) {
			console.error("Error updating super admin status:", error);
		}
	}

	const handleAccountAlertToggle = async (rs) => {
		const url = `${process.env.REACT_APP_API_URL}/user/update`;
		const data = {
			id: rs.id,
			account_alert: !rs.account_alert,
			customer_id: id
		}
		try {
			await fetchWrapper.post(url, data);
			LoadUser();
		} catch (error) {
			console.error("Error updating account alert status:", error);
		}
	}
	return (
		<>
			<PageLoader isLoading={loading} />
			<CustomModalLink
				showModalButtonText={modalHeader}
				modalHeader={modalHeader}
				isOpenEdit={isOpenEdit}
				onCloseEdit={meCloseEdit}
				onOpenEdit={onOpenEdit}

				modalBody={modalEditView}
			/>
			<Header />
			<BoxWrapper>
				<Box >

					<HStack justifyContent="space-between" mb={4} align="flex-start">
						<Box>
							<Text fontSize="22px" fontWeight="700" color="#111827" my="0px" fontFamily="'Open Sans', sans-serif" letterSpacing="-0.01em">Customer Detail</Text>
							<Text fontSize="13px" color="gray.500" mt="2px">Account overview and configuration</Text>
						</Box>
					</HStack>

					<HStack className="customer_main_data_section" mb={4} align="stretch" flexWrap="wrap">
						<Box className="customer_box">
							<Flex align="center" justify="center" boxSize="26px" borderRadius="8px" bg="brand.50" mb="8px">
								<Icon as={LuBuilding2} color="brand.500" boxSize={3.5} />
							</Flex>
							<Heading fontSize="15px" fontWeight="700" color="#111827" letterSpacing="-0.01em">{detail.business_name || '—'}</Heading>
							<Text fontSize="12px" color="gray.500" mt="1px">Business Name</Text>
						</Box>
						<Box className="customer_box">
							<Flex align="center" justify="center" boxSize="26px" borderRadius="8px" bg="brand.50" mb="8px">
								<Icon as={LuUser} color="brand.500" boxSize={3.5} />
							</Flex>
							<Heading fontSize="15px" fontWeight="700" color="#111827">{detail.name || '—'}</Heading>
							<Text fontSize="12px" color="gray.500" mt="1px">Contact Person</Text>
						</Box>
						<Box className="customer_box">
							<Flex align="center" justify="center" boxSize="26px" borderRadius="8px" bg="brand.50" mb="8px">
								<Icon as={LuPhone} color="brand.500" boxSize={3.5} />
							</Flex>
							<Heading fontSize="15px" fontWeight="700" color="#111827">{detail.contact_no || '—'}</Heading>
							<Text fontSize="12px" color="gray.500" mt="1px">Contact No</Text>
						</Box>
						<Box className="customer_box">
							<Flex align="center" justify="center" boxSize="26px" borderRadius="8px" bg="brand.50" mb="8px">
								<Icon as={LuTag} color="brand.500" boxSize={3.5} />
							</Flex>
							<Heading fontSize="15px" fontWeight="700" color="#111827">{detail?.Account?.name || '—'}</Heading>
							<Text fontSize="12px" color="gray.500" mt="1px">Account Type</Text>
						</Box>
						<Box className="customer_box">
							<Flex align="center" justify="center" boxSize="26px" borderRadius="8px" bg="brand.50" mb="8px">
								<Icon as={LuWallet} color="brand.500" boxSize={3.5} />
							</Flex>
							<Heading fontSize="15px" fontWeight="700" color="brand.600">{detail.credit_limit ?? '—'}</Heading>
							<Text fontSize="12px" color="gray.500" mt="1px">Credit Limit</Text>
						</Box>
						<Box className="customer_box">
							<Flex align="center" justify="space-between" mb="8px">
								<Flex align="center" justify="center" boxSize="26px" borderRadius="8px" bg="brand.50">
									<Icon as={LuServer} color="brand.500" boxSize={3.5} />
								</Flex>
								<Box onClick={() => meEdit('server')} cursor="pointer">
									<Link>
										<Image src={customer_edit_icon} h="14px" opacity="0.6" _hover={{ opacity: 1 }} />
									</Link>
								</Box>
							</Flex>
							<Wrap spacing="6px" mb="4px">
								{detail.server_ip?.split(',').map((ip, index) => (
									<WrapItem key={index}>
										<Tag colorScheme="blue" borderRadius="4px" px={2} py="2px" fontWeight="500" fontSize="11px">
											{ip.trim()}
										</Tag>
									</WrapItem>
								))}
							</Wrap>
							<Text fontSize="12px" color="gray.500">Server IP</Text>
						</Box>
					</HStack>

					<Tabs className="customer_tabs_section" onChange={handleTabChange} index={activeTab}>
						<TabList className="customer_tabs_head_section" >
							{/* <Tab>Analytics</Tab> */}
							{/* <Tab>Template Mapping</Tab> */}
							<Tab>Message Log</Tab>
							<Tab>Transactions</Tab>

							<Tab>Users</Tab>
							<Tab>Channel TPS</Tab>
							<Tab>Allowed Country</Tab>
							<Tab>Duplicate Settings</Tab>
							<Tab>Check Validation</Tab>
							<Tab>Page Permission</Tab>
							<Tab>Text Template</Tab>
							<Tab>Support</Tab>
							<Tab>Story Builder AI</Tab>
							<Tab>Opt In / Opt Out</Tab>



						</TabList>

						<TabPanels>
							{/* <TabPanel className="analytics_panel_section">


							<HStack mb="30px">
								<Box className="analytics_box_section">
									<Heading>{listLog?.data?.length}</Heading>

									<Text>Messages Request</Text>
								</Box>

								<Box className="analytics_box_section">
									<Heading>{listLog?.msgSentCount}</Heading>

									<Text>Messages Successfully Delivered</Text>
								</Box>

								<Box className="analytics_box_section">
									<Heading>{listLog?.msgFail}</Heading>

									<Text>Messages Failed</Text>
								</Box>
							</HStack>

							<Box className="chart_box">
								<DailyMessageChart datalist={dailymsg} />
							</Box>

							<Box className="chart_box">
								<CountryWiseChart datalist={countrymsg} />
							</Box>

							<Box className="chart_box">
								<CountryWiseCost datalist={countryCost} />
							</Box>

						</TabPanel> */}
							{/* <TabPanel className="template_panel_section">


							<TemplateMapping id={id} formData={formData} messageTemplateTypeList={messageTemplateTypeList} messageTemplateList={messageTemplateList} />


						</TabPanel> */}
							<TabPanel className="customer_transaction_panel">


								<MessageLog id={id} />



							</TabPanel>
							<TabPanel className="customer_transaction_panel">


								<Transaction id={id} />

							</TabPanel>


							<TabPanel className="customer_transaction_panel">
								<div className="table_section">
									<div style={{display:"flex",justifyContent:"flex-end"}}>
										{(activeTab === 2) && (
											<Button onClick={meAddUser}>
												Add New User
											</Button>
										)}
									</div>
									<TableContainer width="100%">
										<Table variant='simple' width="100%">
											<Thead>
												<Tr>
													<Th>Full Name</Th>
													<Th>User ID</Th>
													<Th>Status</Th>
													<Th>Super Admin</Th>
													<Th>Account Alert</Th>
													<Th></Th>
													<Th></Th>
												</Tr>
											</Thead>
											<Tbody fontSize="14px">
												{listUser?.map((rs, index) => (
													<Tr key={rs?.id || index}>
														<Td fontWeight="500" color="#111827">{rs.username}</Td>
														<Td color="#6b7280" fontSize="13px">{rs.email}</Td>
														<Td>
															<Switch
																colorScheme="blue"
																isChecked={rs.status_id === 1}
																onChange={() => handleActiveInActive(rs)}
															/>
														</Td>
														<Td>
															<Switch
																colorScheme="blue"
																isChecked={rs.super_admin === 1}
																onChange={() => handleSuperAdminToggle(rs)}
															/>
														</Td>
														<Td>
															<Switch
																colorScheme="blue"
																isChecked={!!rs.account_alert}
																onChange={() => handleAccountAlertToggle(rs)}
															/>
														</Td>
														<Td>
															<Text
																fontSize="13px"
																color="#1e4ed8"
																fontWeight="500"
																cursor="pointer"
																_hover={{ textDecoration: 'underline' }}
																onClick={() => meChangePass(rs)}
															>
																Change Password
															</Text>
														</Td>
														<Td>
															<Menu>
																<MenuButton
																	as={Button}
																	size="xs"
																	variant="outline"
																	rightIcon={<Icon as={LuChevronDown} />}
																	borderColor="#d1d5db"
																	color="#374151"
																	fontWeight="500"
																	_hover={{ bg: "#f3f4f6" }}
																>
																	Action
																</MenuButton>
																<MenuList minWidth="140px">
																	<MenuItem fontSize="13px" onClick={() => changeStatus('edit', rs)}>Edit</MenuItem>
																</MenuList>
															</Menu>
														</Td>
													</Tr>
												))}
											</Tbody>
										</Table>
									</TableContainer>
								</div>
							</TabPanel>
							<TabPanel className="customer_transaction_panel">
								<TpsChannel id={id} rs={detail} />
							</TabPanel>
							<TabPanel className="customer_transaction_panel">
								<AllowedCountriesManagement customer={detail} />
							</TabPanel>
							<TabPanel className="customer_transaction_panel">
								<DuplicateSetting customer={detail} />
							</TabPanel>

							<TabPanel className="customer_transaction_panel">
								<CustomerValidation id={id} />
							</TabPanel>
							<TabPanel className="customer_transaction_panel">
								<PagePermission id={id} />
							</TabPanel>
							<TabPanel className="customer_transaction_panel">
								<TextTemplate id={id} customer={detail} />
							</TabPanel>

							<TabPanel className="customer_transaction_panel">
								<CustomerSupport id={id} customer={detail} />
							</TabPanel>
							<TabPanel className="customer_transaction_panel">
								<StoryBuilderAI id={id} customer={detail} />
							</TabPanel>
							<TabPanel className="customer_transaction_panel">
								<OptInOut id={id} customer={detail} />
							</TabPanel>
						</TabPanels>
					</Tabs>
				</Box>
			</BoxWrapper>
		</>
	)
}

export default CustomerDetail